module.exports = __webpack_public_path__ + "img/car_0009.adbe7c62.jpg";